import { isInCooldown } from './isInCooldown';
import { MIN_QUALIFYING_CONVERSATIONS } from './MIN_QUALIFYING_CONVERSATIONS';
import { readFromStorage } from './readFromStorage';

export const isCsatEligible = (): boolean => {
	const data = readFromStorage();
	return !isInCooldown(data) && data.qualifyingConversations >= MIN_QUALIFYING_CONVERSATIONS;
};
